import { render, staticRenderFns } from "./NewFeedPage.vue?vue&type=template&id=18fcfdb7&scoped=true&"
import script from "./NewFeedPage.vue?vue&type=script&lang=js&"
export * from "./NewFeedPage.vue?vue&type=script&lang=js&"
import style0 from "./NewFeedPage.vue?vue&type=style&index=0&id=18fcfdb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcfdb7",
  null
  
)

export default component.exports